import { Box, BoxProps, Button, ModalDialogNew, RadioButton, Text, TextProps } from '@jfs/ui-new'
import { Dimensions, Platform, Alert } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'

import { CommonActions, useNavigation } from '@react-navigation/native'
import { useState } from 'react'
import { SvgImage } from '../../../comps/SvgImage'
import { ToastPosition, ToastType } from '../../../comps/Toast'
import { RootStore, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { languageStrings } from '../../../util/languageStrings'
import { NotificationServiceModule } from '../../../util/util'

interface SelectLanguageModelProps {
  show: boolean
  onDismiss: () => void
}

export const SelectLanguageModel = ({ show, onDismiss }: SelectLanguageModelProps) => {
  const { selectedAppLanguage, updateSelectedAppLanguage } = useStores((root) => ({
    selectedAppLanguage: root.settings.config.selectedAppLanguage,
    updateSelectedAppLanguage: root.settings.config.updateSelectedAppLanguage,
  }))

  const LANGUAGE_LIST_DATA = Object.keys(languageStrings)
  const navigation = useNavigation()

  const [selectedLanguage, setSelectedLanguage] = useState(selectedAppLanguage ?? 'English')

  const onLanguageSelected = () => {
    updateSelectedAppLanguage(selectedLanguage)
        
     NotificationServiceModule?.setNotificationSettings('selectedLanguage', selectedLanguage)
        setSelectedLanguage({ ...selectedLanguage, status: 'NOT_STARTED' })
    NotificationServiceModule?.stopSound()

    if (Platform.OS ===  'android')
    {
          RootStore?.response?.setCustomToast({
          message: 'Language update to ' + selectedLanguage,
          position: ToastPosition.BOTTOM,
          toastType: ToastType.POSITIVE,
          })
    }
    else
    {
        Alert.alert(
                'Language updated',
                `Language updated to ${selectedLanguage}`
          );
    }

    onDismiss()
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: Routes.ROOTSCREEN } as never],
      }),
    )
  }

  return (
    <ModalDialogNew animate={true} show={show} type="bottom" backgroundColor="TRANSPARENT">
      <Box {...styles.container}>
        <Box flexDirection={'row'} alignSelf={'stretch'} alignItems={'center'} pv={20} mt={20}>
          <Box maxWidth={'80%'}>
            <Text {...styles.headerText}>Select language</Text>
          </Box>
          <Box
            flex={1}
            alignItems="flex-end"
            justifyContent={'center'}
            testID="close-lang"
            onPress={() => {
              onDismiss()
            }}
            underlayColor="TRANSPARENT">
            <SvgImage width={24} height={24} imageName="Close" />
          </Box>
        </Box>
        <Box height={Dimensions.get('screen').height / 2}>
          <FlatList
            showsVerticalScrollIndicator={false}
            data={LANGUAGE_LIST_DATA}
            renderItem={({ item }) => {
              return (
                <LanguageListItem
                  item={item}
                  checkedItem={selectedLanguage}
                  onLanguageChange={(lang: any) => {
                    setSelectedLanguage(lang)
                  }}
                />
              )
            }}
          />
        </Box>
        <Box pt={20}>
          <Button isFull isRound onPress={onLanguageSelected} testID="select-lang" height={48}>
            <Text color="WHITE" fontSize={16} lineHeight={24} fontFamily="JioType-Bold">
              Continue
            </Text>
          </Button>
        </Box>
      </Box>
    </ModalDialogNew>
  )
}
interface LanguageListItemProps {
  item: any
  checkedItem: {
    language: string
    status: 'NOT_STARTED' | 'LOADING' | 'PLAYING' | 'COMPLETED_OR_ERROR'
  }
  onLanguageChange: any
}
export const LanguageListItem = ({ item, checkedItem, onLanguageChange }: LanguageListItemProps) => {
  const onLanuageSelected = () => {
    onLanguageChange(item)
  }

  return (
    <Box {...styles.languageListItemContainer} testID="submit-lang" onPress={onLanuageSelected}>
      <Box flexDirection={'row'} width={'75%'} justifyContent={'space-between'}>
        <Box width={'50%'}>
          <Text {...styles.languageText}>{item}</Text>
        </Box>
        {/* <Box width={'50%'}>
          <Text {...styles.descText}>{item !== 'English' && item}</Text>
        </Box> */}
      </Box>

      <Box justifyContent={'flex-end'} flexDirection="row" width={'20%'}>
        <RadioButton checked={item === checkedItem} size={20} onChange={onLanuageSelected} />
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    backgroundColor: 'WHITE',
    pb: 24,
    ph: 24,
  } as BoxProps,
  languageListItemContainer: {
    flexDirection: 'row',
    underlayColor: 'GRAY_BORDER',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 55,
  } as BoxProps,
  languageText: {
    fontSize: 16,
    fontFamily: 'JioType-Bold',
    lineHeight: 24,
    color: 'BLACK_21',
  } as TextProps,
  descText: {
    fontSize: 16,
    fontFamily: 'JioType-Medium',
    lineHeight: 24,
    color: 'PRIMARY_GREY',
  } as TextProps,
  headerText: {
    fontSize: 24,
    lineHeight: 28,
    fontFamily: 'JioType-Black',
    color: 'BLACK_21',
  } as TextProps,
}
